import "../index.css";
import { RequestPasswordResetScreen } from "./forgotten-password/request-password-reset-screen.tsx";
import { UserLoginSignUpScreen } from "./user-login-sign-up-screen.tsx";
import { ResetPasswordScreen } from "./forgotten-password/reset-password-screen.tsx";
import { MarketingPreferencesScreen } from "./sign-up/account-activation/marketing-preferences-screen.tsx";
import { AccountActivationErrorScreen } from "./sign-up/account-activation/account-activation-error-screen.tsx";
import { reactHydrate } from "../react-hydrate.ts";

window.Components = {
  UserLoginSignUpScreen,
  ForgottenPasswordScreen: RequestPasswordResetScreen,
  ResetPasswordScreen,
  MarketingPreferencesScreen,
  AccountActivationErrorScreen,
};

reactHydrate();
